<template>
  <div
    class="xl:w-4/5 md:w-11/12 xl:my-10 md:my-4
     md:mx-auto m-1 bg-gray-50 rounded"
  >
    <EditForm
      :row="Array(headings.length)"
      :headers="headings"
      :submitEdit="submitEdit"
      v-if="show"
    />
    <div class="flex flex-row justify-center p-4 w-full">
      <div class="flex ml-auto">
        <div>
          <h1 class="font-semibold xl:text-xl ">Manage Office Leaders:</h1>
        </div>
        &nbsp;
      </div>
      <t-button
        variant="success"
        class="float-right ml-auto"
        @click="show = true"
        >Insert New Record</t-button
      >
      <br />
    </div>
    <div class="p-4 w-auto">
      <t-alert variant="info" show v-on:hidden="setCookie" v-if="noCookie()">
        Office members in this page will be receiving notication emails <br />
      </t-alert>
    </div>
      <Table
        :items="items"
        :del="del"
        :edit="edit"
        :getTheDataInParent="getTheData"
      />
    <div class="flex">
      <div class="font-semibold text-l p-2 m-1">
        Set reminder frequency:
      </div>
      <div class="flex flex-wrap m-1">
        <div class="flex p-2">
          <div>
            <h1 class="font-semibold xl:text-xl ">Month:</h1>
          </div>
          &nbsp;
          <div>
            <select
              name="Select Month"
              @change="handleSelected($event)"
              v-model="selectedMonth"
              class=" xl:text-xl  "
            >
              <option
                v-for="month in MONTHS"
                :value="month.num"
                v-bind:key="month.num"
                class="hover:border-orange-600"
                >{{ month.name }}</option
              >
            </select>
          </div>
        </div>

        <div class="flex p-2 ">
          <div>
            <h1 class="font-semibold xl:text-xl ">Day:</h1>
          </div>
          &nbsp;
          <div>
            <select
              name="Select Day"
              @change="handleSelected($event)"
              v-model="selectedDay"
              class=" xl:text-xl  "
            >
              <option
                v-for="day in DAYS"
                :value="day.num"
                v-bind:key="day.num"
                class="hover:border-orange-600"
                >{{ day.name }}</option
              >
            </select>
          </div>
        </div>

        <div class="flex p-2">
          <div>
            <h1 class="font-semibold xl:text-xl ">Hour:</h1>
          </div>
          &nbsp;
          <div>
            <select
              name="Select Hour"
              @change="handleSelected($event)"
              v-model="selectedHour"
              class=" xl:text-xl  "
            >
              <option
                :value="i"
                v-for="i in HOURS"
                v-bind:key="i"
                class="hover:border-orange-600"
                >{{ i }}</option
              >
            </select>
          </div>
        </div>

        <div class="flex p-2">
          <div>
            <h1 class="font-semibold xl:text-xl ">Minute:</h1>
          </div>
          &nbsp;
          <div>
            <select
              name="Select Minute"
              @change="handleSelected($event)"
              v-model="selectedMinute"
              class=" xl:text-xl  "
            >
              <option
                :value="i"
                v-for="i in MINUTES"
                v-bind:key="i"
                class="hover:border-orange-600"
                >{{ i }}</option
              >
            </select>
          </div>
        </div>
        <div class="p-2">
          <t-button @click="handleSubmitTimes">Save</t-button>
        </div>
      </div>
      </div>
  </div>
</template>

<script>
import Table from './Table';
import EditForm from './EditForm';

export default {
  components: {
    Table,
    EditForm,
  },
  mounted() {
    this.getTheData();
    this.getScheduleReminder();
  },
  methods: {
    async getScheduleReminder() {
      fetch(
        `${process.env.VUE_APP_API_URL}/get_schedule_reminder`,
        {
          method: 'POST',
          headers: {},
          body: `{"jwt": "${localStorage.getItem('jwt')}"}`
        },
      )
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          this.selectedDay = response.data.day;
          this.selectedMonth = response.data.month;
          this.selectedMinute = response.data.minute;
          this.selectedHour = response.data.hour;
        });
    },
    handleSubmitTimes() {
      fetch(
        `${process.env.VUE_APP_API_URL}/schedule_reminder`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: `{"jwt": "${localStorage.getItem('jwt')}",\
          "hour":"${this.selectedHour}",\
          "minute":"${this.selectedMinute}",\
          "day":"${this.selectedDay}",\
          "month":"${this.selectedMonth}"}`,
        },
      )
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          console.log(response);
          this.$vToastify.success('Success', response.data);
        })
        .catch((err) => {
          this.$vToastify.error('Failed', err);
          console.error(err);
        });
    },
    handleSelected() {
      this.getTheData();
    },
    edit() {
      alert('this feature is not yet implemented');
    },
    async getTheData() {
      fetch(
        `${process.env.VUE_APP_API_URL}/get_office_members`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            jwt: localStorage.getItem('jwt'),
          }),
        },
      )
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          this.items = response.data;
          this.getHeadings();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async del(row) {
      const res = await fetch(
        `${process.env.VUE_APP_API_URL}/delete_office_member`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            row: row,
            jwt: localStorage.getItem('jwt'),
          }),
        },
      );
      return await res;
    },

    getHeadings: function() {
      try {
        const i = Object.keys(this.items).map((key) => {
          return [Number(key), this.items[key]];
        });

        this.headings = Object.keys(i[0][1]);
        console.log(this.headings);
      } catch (_e) {}
    },

    submitEdit(edit) {
      if (edit === 'cancel') {
        this.show = false;
        return;
      }

      console.log(edit);
      this.show = false;

      this.insert(edit).then((res) => {
        if (res.ok) {
          console.log(res);
          this.$vToastify.success('Successfully carried out edit');
          this.getTheData();
        } else {
          this.$vToastify.error('Could not edit, see console for details');
          console.error(res);
        }
      });
    },

    async insert(edit) {
      const res = fetch(
        `${process.env.VUE_APP_API_URL}/insert_office_member`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            edit: edit,
            jwt: localStorage.getItem('jwt'),
          }),
        },
      );
      return await res;
    },

    setCookie() {
      this.$cookies.set('ManageOfficeMembers-infobox', 'dismissed', 'infinity');
    },
    noCookie() {
      return !(this.$cookies.get('ManageOfficeMembers-infobox') == 'dismissed');
    },
  },
  data() {
    return {
      headings: [],
      show: false,
      items: [],
      selectedDay: 'None',
      DAYS: [
        {name: 'Monday', num: 1},
        {name: 'Tuesday', num: 2},
        {name: 'Wednesday', num: 3},
        {name: 'Thursday', num: 4},
        {name: 'Frnumay', num: 5},
        {name: 'Saturday', num: 6},
        {name: 'Sunday', num: 7},
        {name: 'None', num: 'None'},
      ],
      selectedHour: '0',
      HOURS: Array.from(Array(24).keys()),
      selectedMinute: '0',
      MINUTES: Array.from(Array(60).keys()),
      selectedMonth: 'None',
      MONTHS: [
        {name: 'January', num: 1},
        {name: 'February', num: 2},
        {name: 'March', num: 3},
        {name: 'April', num: 4},
        {name: 'May', num: 5},
        {name: 'June', num: 6},
        {name: 'July', num: 7},
        {name: 'August', num: 8},
        {name: 'September', num: 9},
        {name: 'October', num: 10},
        {name: 'November', num: 11},
        {name: 'December', num: 12},
        {name: 'None', num: 'None'},
      ],
    };
  },
};
</script>

<style></style>
